import { PropsWithChildren, ReactNode } from 'react';

import {
  Divider,
  mergeSx,
  Icons,
  IconButton,
  SxProps,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

export type DrawerHeaderProps = PropsWithChildren<{
  actions?: ReactNode;
  onClose?: () => void;
  noDivider?: boolean;
  sx?: SxProps;
  containerSx?: SxProps;
  sticky?: boolean;
  closeProps?: {
    placement: 'left' | 'right';
  };
}>;

/** @deprecated Use `DrawerHeader` from `@cast/design-system` instead. */
export const DrawerHeader = ({
  actions,
  onClose,
  noDivider,
  children,
  sx,
  containerSx,
  sticky = true,
  closeProps,
}: DrawerHeaderProps) => {
  return (
    <Box
      className="DrawerHeader-root"
      flex={0}
      sx={mergeSx(
        {
          px: 32,
        },
        sticky && {
          '.Drawer-scrolledContent &': {
            boxShadow: tokens.theme.shadows.elevation.medium,
          },
        },
        sx
      )}
    >
      <Stack direction="column" pt={24} mb={8} sx={containerSx}>
        <Stack
          direction={closeProps?.placement === 'right' ? 'row-reverse' : 'row'}
          flexWrap="nowrap"
          justifyContent={
            closeProps?.placement === 'right' ? 'flex-start' : 'space-between'
          }
          gap={8}
        >
          <IconButton
            variant="ghost"
            size="sm"
            sx={closeProps?.placement === 'right' ? { mr: -16 } : { ml: -16 }}
            // ensure no event is passed as the first param
            onClick={onClose && (() => onClose())}
            testId="close-drawer"
          >
            {closeProps?.placement === 'right' ? (
              <Icons.X />
            ) : (
              <Icons.CaretDoubleRight />
            )}
          </IconButton>
          {actions}
        </Stack>
        <Stack>{children}</Stack>
      </Stack>
      {children && !noDivider && <Divider />}
    </Box>
  );
};
